import { decodeToken, setToken } from 'src/hooks';

export class AuthService {
  private static instance: AuthService;
  private getAccessTokenSilently: () => Promise<string>;
  private refreshTimerId: ReturnType<typeof setTimeout> | null = null;

  constructor(getAccessTokenSilently: () => Promise<string>) {
    this.getAccessTokenSilently = getAccessTokenSilently;
  }

  public static setInstance(getAccessTokenSilently: () => Promise<string>) {
    if (!this.instance) {
      this.instance = new AuthService(getAccessTokenSilently);
    }

    this.instance.getAccessTokenSilently = getAccessTokenSilently;
  }

  public static getInstance(): AuthService {
    return this.instance;
  }

  async refreshToken() {
    const accessToken = await this.getAccessTokenSilently();

    setToken(accessToken);
    this.scheduleTokenRefresh(accessToken);
  }

  scheduleTokenRefresh(token: string) {
    if (this.refreshTimerId) {
      clearTimeout(this.refreshTimerId);
      this.refreshTimerId = null;
    }

    const { exp } = decodeToken(token);
    const delay = exp * 1000 - Date.now() - 60_000;

    if (delay > 0) {
      this.refreshTimerId = setTimeout(() => {
        this.refreshToken();
      }, delay);
    }
  }
}
